import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface UpdateBusinessRegNumberParams {
  companyId: string;
  certificateId: number;
  businessRegNumber: string;
}

/**
 * 인증서 사업자번호 업데이트 API
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Certificate%20API/updateBusinessRegistrationNumber
 *
 * @param {string} companyId - 회사 ID
 * @param {number} certificateId - 인증서 ID
 * @param {string} businessRegNumber - 사업자등록번호
 * @returns
 */
export default function updateBusinessRegNumber({
  companyId,
  certificateId,
  businessRegNumber,
}: UpdateBusinessRegNumberParams) {
  return API.put<ResponseBase>(
    `/api/v3/companies/${companyId}/certificates/${certificateId}/business-registration-number`,
    { data: { businessRegNumber } },
  );
}
